module.exports = __webpack_public_path__ + "images/instacart-video-cover.71b97342.jpg";